/* Copyright (c) 2020-present CloudIO Inc */

const isTouchEvent = (
  nativeEvent: TouchEvent | MouseEvent,
): nativeEvent is TouchEvent => nativeEvent.type?.indexOf('touch') === 0;

export default function handleTouchOrMouseEvent(
  event:
    | React.MouseEvent<HTMLElement | SVGElement>
    | React.TouchEvent<HTMLElement | SVGElement>,
):
  | {
      clientX: number;
      clientY: number;
      touch: boolean;
      target: EventTarget;
      event: Touch | MouseEvent;
    }
  | undefined {
  const nativeEvent = event.nativeEvent || event;
  let touch = false;
  let target: EventTarget;
  let e: Touch | MouseEvent;

  if (isTouchEvent(nativeEvent)) {
    if (!nativeEvent.changedTouches.length) {
      return;
    }
    e = nativeEvent.changedTouches[0];
    target = e.target;
    touch = true;
  } else {
    e = nativeEvent;
    target = event.target;
    if (e.button > 0) {
      return;
    }
  }
  const { clientX, clientY } = e;
  return { clientX, clientY, touch, target, event: e };
}
